import React from 'react';
import IProcedureSummary from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureSummary';
import { Guid } from '@Shared.Angular/@types/guid';
import FlowIconSquare from '@Client/runner.directives/common/FlowIconSquare/FlowIconSquare';
import FlowModelSummaryTag from '@Client/runner.shared/FlowModelSummaryTag/FlowModelSummaryTag';

type Props = {
  procedure: IProcedureSummary;
  onClick: (procedureId: Guid) => void;
};

const ProcedureSummary = (props: Props) => {
  const { procedure } = props;

  return (
    <div
      className="procedure-summary"
      data-testid="procedure-summary"
      onClick={() => props.onClick(procedure.id)}
    >
      <FlowIconSquare name={procedure.name} />
      <div className="procedure-content">
        <div className="procedure-info">
          <div className="procedure-details">
            <div className="procedure-name">{procedure.name}</div>
            <div className="procedure-category">
              {procedure.categoryTree.categoryName}
            </div>
          </div>
          <div className="procedure-owner">
            <div>SOP Owner</div>
            <div className="procedure-owner-name">
              {procedure.ownerName || 'N/A'}
            </div>
          </div>
        </div>
        <FlowModelSummaryTag tags={procedure.tags} />
      </div>
    </div>
  );
};

export default ProcedureSummary;
